import { LogoTextIcon } from "$components/icons";
import { Box } from "@material-ui/core";
import getLocationUrl from "./get-location-url";

const Footer = () => (
  <>
    <Box mt={2} mb={1}>
      <LogoTextIcon />
    </Box>
    <Box mb={1}>{getLocationUrl()}</Box>
  </>
);

export default Footer;
